import { OrderHelper } from "./OrderHelper"
import { I18N } from "./I18N"

export class ReceiptPreviewDialog {
	_order
	_store
	_target

	constructor(target, order, store, title = 'Receipt preview') {
		this._order = order
		this._store = store
		this._title = title
		this._target = document.getElementById(target)
		this._target.setAttribute('hidden', '')
	}

	close = () => this.setVisible(false)

	setVisible = visible => {
		if (visible) {
			const isWindows = navigator.userAgent && navigator.userAgent.toLowerCase().includes('windows')
			//const receiptWidthMm = '58'

			let receiptWidthPx = 384 // Width on 58mm roll
			let fontHeightPx = 23 // Font size on 58mm roll
			let receiptWidth = receiptWidthPx + 'px'
			let fontHeight = fontHeightPx + 'px'
			if (isWindows) {
				const receiptWidthMm = '72'
				// let receiptWidthPx = 528 // Width on 80mm roll
				let fontHeightMm = 3.5 // Font size on 80mm roll
				receiptWidth = receiptWidthMm + 'mm'
				fontHeight = fontHeightMm + 'mm'
			}

			const css = OrderHelper.getCss(receiptWidth, fontHeight)
			const innerHtml = OrderHelper.getHtml(this._order, this._store)

			// Render preview Dialog
			this._target.innerHTML = `
				<div class="modalCanvas">
				<div id="receiptPreviewModalShader" class="modalShader"></div>
				<div class="card modal">
					<button id="receiptPreviewCloseBtn" class="closeBtn"><span class="material-icons">close</span></button>
					<div class="dlgTopSpacer"><h2 i18n>${this._title}</h2></div>
					<div class="card" style="width: fit-content;">
						<div>
							<style type="text/css">
								${css}
							</style>
							${innerHtml}
						</div>
					</div>
				</div>
			`
			I18N.translateElement(this._target)
			this._target.removeAttribute('hidden')
			window.scrollTo(0, 0)
			// Close button
			document.getElementById('receiptPreviewCloseBtn').addEventListener('click', () => this.setVisible(false))
			document.getElementById('receiptPreviewModalShader').addEventListener('click', () => this.setVisible(false))
		}
		else {
			this._target.innerHTML = ''
			this._target.setAttribute('hidden', '')
		}
	}
}